import {
  differenceBy,
  flatten,
  forEach,
  intersectionBy,
  isArray,
  isEmpty,
  map,
  remove,
  uniqBy
} from 'lodash';

import { ApiService } from '@nrwl/common-lib';
import { BaseWizardStep } from '../base.wizard.step';
import { UserAuth } from '@nrwl/common-lib';

export class UserWizardStep extends BaseWizardStep {
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
  constructor(apiService: ApiService, config: any, parent: any, readonly userAuth: UserAuth) {
    super(apiService, config, parent);

    if (this.config.def.subContent) {
      this.subContent = new UserWizardStep(apiService, config.def.subContent, this, userAuth);
    }
  }

  //---------------------------------------- Request/Format Data -------------------------------------------------------

  _requestData(
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types,@typescript-eslint/no-explicit-any
    subPath: any,
    onSuccess = () => {
      // Empty function
    },
    key = null
  ): void {
    if (isEmpty(this.config.def.dataUrl) || this._isEmptyFields()) {
      return;
    }

    if (isArray(this.config.def.dataUrl)) {
      forEach(this.config.def.dataUrl, item => {
        this._requestSingleData(item.url, item.key, onSuccess);
      });
    } else {
      this._requestSingleData(this._generateURL(subPath), key, onSuccess);
    }
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types,@typescript-eslint/no-explicit-any
  _onSuccessfulRequest(key: any, dataSource: any): any {
    // user administration add group changes

    if (this.config.def.dataSourceKey === 'groupIds') {
      for (let i = 0; i < dataSource.length; i++) {
        dataSource[i].id = dataSource[i].groupId;
      }
    }

    // OLPTC-3256 - Remove read-only roles
    if (this.config.def.dataSourceKey === 'roleIds') {
      this.userAuth.removeRoles(dataSource);
    }

    super._onSuccessfulRequest(key, dataSource);
    const filterDataSource = this.config.def.filterDataSource;
    if (filterDataSource) {
      if (filterDataSource.hide) {
        this.dataSource = this.filterData(
          dataSource,
          this.output[filterDataSource.hide],
          filterDataSource.key
        );
        this.output[filterDataSource.hide] = [];
      } else {
        forEach(this.output[filterDataSource.show], item => {
          item.isChecked = false;
        });
        const output = this.output[filterDataSource.show];
        this.output[filterDataSource.show] = [];
        this.dataSource = intersectionBy(dataSource, output, filterDataSource.key);
      }
      this.dataSourceObservable.next(this.dataSource);
    }
    if (this.parent.defaultParamsById['add_remove_group'] === 'add_remove_group') {
      const filteredData = dataSource.filter(
        element => !this.parent.defaultParamsById.groupIds.some(item => element.id === item.id)
      );

      //ATW-4727 - remove readonly group when other group already selected
      const isReadOnlyUser = this.parent.defaultParamsById.groupIds.some(
        item => item.name === 'readonly'
      );
      if (this.parent.defaultParamsById.groupIds.length) {
        if (isReadOnlyUser) {
          //Disable other group when user is already readonly user
          filteredData.forEach(data => (data.disabled = true));
        } else {
          filteredData.forEach(data => (data.disabled = data.name === 'readonly'));
        }
      }
      this.dataSource = filteredData;
      this.dataSourceObservable.next(this.dataSource);
    }
  }

  //-------------------------------------------- Filters ---------------------------------------------------------------

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types , @typescript-eslint/no-explicit-any
  filterData(source: any, target: any, by: any) {
    if (this.parent.id === 'wizardService.inv_user.inv_user' && by === 'groupId') {
      forEach(source, group => {
        forEach(group.roles, role => {
          role.name = this.userAuth.getRoleDescriptionName(role.id);
        });
      });
    }
    if (this.parent.canManageUsersResults) {
      remove(source, item => item.id === 'read-only');
    }
    return differenceBy(source, target, by);
  }

  //--------------------------------------------- list actions ---------------------------------------------------------

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types,@typescript-eslint/no-explicit-any
  getDistinctItemFromGroups(source: any, key: any, uniqueBy: any): any {
    return uniqBy(flatten(map(source, item => item[key])), uniqueBy);
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
  removeItem(list: any, item: any): void {
    remove(list, item);
  }
}
